import PhotoSwipeLightbox from "photoswipe/lightbox"

// Set as data-pswp-placeholder when the link's thumbnail isn't a preview of the full image (e.g. a logo)
const NO_PLACEHOLDER = "none"

document.addEventListener("DOMContentLoaded", () => {
  initGalleries()
})

function initGalleries() {
  document
    .querySelectorAll(".photoswipe-container")
    .forEach(async (gallery) => {
      await Promise.all(
        [...gallery.querySelectorAll(".photoswipe-image")].map(
          (imageHolder) => {
            return new Promise((resolve) => {
              const img = imageHolder.querySelector("img")

              if (imageHolder.hasAttribute("data-pswp-width") || !img) {
                return resolve()
              }

              const refreshPhotoswipeSize = () => {
                imageHolder.setAttribute("data-pswp-width", img.naturalWidth)
                imageHolder.setAttribute("data-pswp-height", img.naturalHeight)
                resolve()
              }

              if (img.complete) {
                return refreshPhotoswipeSize()
              }

              img.onload = () => {
                refreshPhotoswipeSize()
              }

              img.onerror = () => resolve()
            })
          },
        ),
      )

      const lightbox = new PhotoSwipeLightbox({
        gallery: gallery,
        children: ".photoswipe-image",
        initialZoomLevel: "fit",
        secondaryZoomLevel: "fit",
        showHideAnimationType: "none",
        pswpModule: () => import("photoswipe"),
      })

      lightbox.addFilter("domItemData", (itemData, _element, linkEl) => {
        if (linkEl?.dataset.pswpPlaceholder === NO_PLACEHOLDER) {
          delete itemData.msrc
        }

        return itemData
      })

      lightbox.on("uiRegister", () => {
        lightbox.pswp.ui.registerElement({
          name: "custom-caption",
          order: 9,
          isButton: false,
          appendTo: "root",
          onInit: (captionElement, pswp) => {
            pswp.on("change", () => {
              const { element } = pswp.currSlide.data

              if (!element) {
                return
              }

              const imageElement = element.querySelector("img")

              const caption =
                element.dataset.pswpCaption ||
                imageElement?.getAttribute("title") ||
                imageElement?.getAttribute("alt")

              if (!caption) {
                captionElement.style.display = "none"

                return
              }

              captionElement.style.display = "block"
              captionElement.innerHTML = caption
            })
          },
        })
      })

      lightbox.init()
    })
}
